export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-10.c5b23e21.jpg";